<template>
<div class="chapter">
<div class="inner_page">
<p class="ind" id="epigraph" style="margin-top:20px;"><a id="start">This is the true account, when all was vague, all was silence, without motion and the sky was still empty. This is the first account, the first narrative. There was neither man nor beast, no bird, fish nor crab, no trees, rocks, caves nor canyons, no plants and no shrubs. Only the sky was there.</a></p><a id="start">
<p class="right">—<i>Popol Vuh</i> of the Quiché Maya</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6epigraph.vue?3301f869